import React from "react";
import Blocks from "editorjs-blocks-react-renderer";
import ImageRenderer from "../imageRenderer";

import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Button from "../button";
const TextPhotoButton = ({ data }) => {
  if (!data) {
    return null;
  }
  const image = getImage(data?.Photo?.localFile);
  return (
    <section className="p-5 TextPhotoButton">
      <div className="mx-auto max-w-screen-xl xxl:max-w-screen-3xl lg:my-18 my-12 prose">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2  my-4">
            <h2 className="lg:text-5xl text-2xl font-bold leading-[54px]">
              {data.TitleH2}
            </h2>
            <h3 className=" lg:text-2xl text-xl font-normal">
              {data.SubTitleH3}
            </h3>
            {data?.RichText?.data?.RichText ? (
              <div className="font-normal text-lg font-sans leading-8">
                <Blocks
                  data={JSON.parse(data.RichText.data.RichText)}
                  renderers={{
                    image: ImageRenderer,
                  }}
                />
              </div>
            ) : (
              ""
            )}
            {data.Button?.ShowButton && <Button data={data.Button} />}
          </div>
          <div
            className={`lg:w-1/2 w-full   object-contain ${
              data.PhotoLeft ? "-order-1" : ""
            }`}
          >
            <GatsbyImage
              image={image}
              alt="image"
              className="w-full h-full max-h-[522px]  rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextPhotoButton;
